import { GetFinanceTradesApi } from "@/features/accounts/finance/services/get-trades-api";
import { GetFinanceTradesRequestModel } from "@/features/accounts/finance/services/get-trades-model";

/// 銀行明細一覧取得処理
export class GetFinanceTradesService {
  private getFinanceTradesApi = new GetFinanceTradesApi();

  /**
   * 銀行明細一覧取得API実行
   */
  public async getFinanceTrades(param: GetFinanceTradesRequestModel) {
    return await this.getFinanceTradesApi.getFinanceTrades(param);
  }
}
